import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Offcanvas } from 'react-bootstrap';
import { AuthContext } from '../App';
import Footer from './Footer';
import envConfig from '../envConfig';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx'; // Import xlsx for Excel generation
function Fisherman(props) {
    const { isAuthenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showBulkUpload, setShowBulkUpload] = useState(false);
    const [countries, setCountries] = useState(null);
    const [provinces, setProvinces] = useState(null);
    const [districts, setDistricts] = useState(null);
    const [villages, setVillages] = useState(null);
    const [filteredProvinces, setFilteredProvinces] = useState(null);
    const [filteredDistricts, setFilteredDistricts] = useState(null);
    const [filteredVillages, setFilteredVillages] = useState(null);
    const [fisherMen, setFisherMen] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedVillage, setSelectedVillage] = useState(null);
    const [formError, setFormError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [totalRows, setTotalRows] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const [offcanvasCountry, setOffcanvasCountry] = useState('');
    const [offcanvasProvinces, setOffcanvasProvinces] = useState(null);
    const [offcanvasDistricts, setOffcanvasDistricts] = useState(null);
    const [offcanvasVillages, setOffcanvasVillages] = useState(null);
    const [offcanvasProvince, setOffcanvasProvince] = useState('');
    const [offcanvasDistrict, setOffcanvasDistrict] = useState('');
    const [offcanvasVillage, setOffcanvasVillage] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [languageId, setLanguageId] = useState('');
    const [speciesId, setSpeciesId] = useState('');
    const [advisoryPreferenceId, setAdvisoryPreferenceId] = useState('');
    const [offcanvasFormError, setOffcanvasFormError] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedFisherId, setSelectedFisherId] = useState(null);
    const [activeTab, setActiveTab] = useState(null);
    const [uploadFile, setUploadFile] = useState(null);
    const [languages, setLanguages] = useState([]);
    const [species, setSpecies] = useState([]);
    const [frequencies, setFrequencies] = useState([]);
    useEffect(() => {
        if (selectedCountry) {
            setOffcanvasCountry(selectedCountry);
        }
    }, [selectedCountry]);
    const handleClose = () => {
        setShow(false);
        // Reset Offcanvas form
        // setOffcanvasCountry('');
        setOffcanvasProvince('');
        setOffcanvasDistrict('');
        setOffcanvasVillage('');
        setName('');
        setPhone('');
        setEmail('');
        setLanguageId('');
        setSpeciesId('');
        setAdvisoryPreferenceId('');
        // setOffcanvasProvinces(null);
        // setOffcanvasDistricts(null);
        // setOffcanvasVillages(null);
        setOffcanvasFormError(null);
        setIsEditMode(false);
        setSelectedFisherId(null);
    };
    const handleShow = () => setShow(true);
    const handleCloseBulkUpload = () => {
        setShowBulkUpload(false);
        setUploadFile(null);
        const fileInput = document.getElementById('file-input');
        if (fileInput) {
            fileInput.value = null;
        }
    };
    const handleShowBulkUpload = () => setShowBulkUpload(true);
    const reset = () => {
        setSearchTerm('');
        setPageNo(1);
        setSelectedRows([]);
        if (!selectedCountry) {
            setFormError('Please select a country before searching.');
            return;
        }
        fetchFishermen('');
    };
    const handleEdit = (fisherman) => {
        setIsEditMode(true);
        setSelectedFisherId(fisherman.fisher_id);
        setName(fisherman.name);
        setPhone(fisherman.phone);
        setEmail(fisherman.email || '');
        setLanguageId(fisherman.language_id || '');
        setSpeciesId(fisherman.species_id || '');
        setAdvisoryPreferenceId(fisherman.advisory_preference_id || '');
        setOffcanvasCountry(fisherman.country_id || '');
        setOffcanvasProvince(fisherman.adm1_id || '');
        setOffcanvasDistrict(fisherman.adm2_id || '');
        setOffcanvasVillage(fisherman.adm3_id || '');
        setShow(true);
    };
    const handleDelete = async (fisherman) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete ${fisherman.name}? This action cannot be undone.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        });
        if (result.isConfirmed) {
            const payload = {
                country_id: parseInt(selectedCountry),
                fisher_id: fisherman.fisher_id,
            };
            try {
                const response = await fetch(`${envConfig.API_URL}/fishermen`, {
                    method: 'DELETE',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(payload),
                });
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                await Swal.fire({
                    title: 'Deleted!',
                    text: `${fisherman.name} has been deleted.`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
                const newTotalRows = totalRows - 1;
                const recordsOnCurrentPage = newTotalRows - (pageNo - 1) * perPage;
                if (recordsOnCurrentPage <= 0 && pageNo > 1) {
                    setPageNo(pageNo - 1);
                } else if (newTotalRows === 0) {
                    setPageNo(1);
                }
                setTotalRows(newTotalRows);
                await fetchFishermen();
            } catch (error) {
                setFormError(handleApiError(error, error.response));
                Swal.fire({
                    title: 'Error!',
                    text: formError || 'Failed to delete the fish farmer.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            }
        }
    };
    const handleActivate = async (fisherman) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to make this user active?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, activate!',
            cancelButtonText: 'Cancel',
        });
        if (result.isConfirmed) {
            const payload = {
                country_id: parseInt(selectedCountry),
                fisher_id: fisherman.fisher_id,
                purpose: 'reactivate',
            };
            try {
                const response = await fetch(`${envConfig.API_URL}/fishermen`, {
                    method: 'PATCH',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(payload),
                });
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                await Swal.fire({
                    title: 'Activated!',
                    text: `${fisherman.name} has been activated.`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
                const newTotalRows = totalRows - 1;
                const recordsOnCurrentPage = newTotalRows - (pageNo - 1) * perPage;
                if (recordsOnCurrentPage <= 0 && pageNo > 1) {
                    setPageNo(pageNo - 1);
                } else if (newTotalRows === 0) {
                    setPageNo(1);
                }
                setTotalRows(newTotalRows);
                await fetchFishermen();
            } catch (error) {
                setFormError(handleApiError(error, error.response));
                Swal.fire({
                    title: 'Error!',
                    text: formError || 'Failed to activate the fish farmer.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            }
        }
    };
    const handlePhoneChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,16}$/.test(value)) {
            setPhone(value);
            setOffcanvasFormError(null);
        } else {
            setOffcanvasFormError('Phone must be a maximum of 16 digits with no special characters.');
        }
    };
    useEffect(() => {
        if (!isAuthenticated) {
            window.location.href = '/login';
        }
    }, [isAuthenticated, navigate]);
    const getAuthHeaders = () => {
        const token = localStorage.getItem('profishBlue_authToken');
        const expiryTime = localStorage.getItem('profishBlue_tokenExpiry');
        const isTokenExpired = !token || !expiryTime || Date.now() > parseInt(expiryTime, 10);
        if (isTokenExpired) {
            logout();
            window.location.href = '/login';
            return {};
        }
        return {
            'Content-Type': 'application/json',
            Authorization: token,
        };
    };
    const handleApiError = (error, response) => {
        if (
            response &&
            response.status === 401 &&
            error.message.includes('Your authentication token is invalid')
        ) {
            setTimeout(() => {
                logout();
                window.location.href = '/login';
            }, 0);
            return 'Session expired. Please log in again.';
        }
        return error.message || 'An error occurred. Please try again.';
    };
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch(`${envConfig.API_URL}/lookups/locations/country`, {
                    headers: getAuthHeaders(),
                });
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setCountries(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };
        if (isAuthenticated) {
            fetchCountries();
        }
    }, [isAuthenticated]);
    useEffect(() => {
        const fetchProvinces = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm1?country_id=${selectedCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setProvinces(data.data || []);
                setFilteredProvinces(data.data || []);
                setSelectedProvince(null);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };
        const fetchDistricts = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm2?country_id=${selectedCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setDistricts(data.data || []);
                setFilteredDistricts(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };
        const fetchVillages = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm3?country_id=${selectedCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setVillages(data.data || []);
                setFilteredVillages(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };
        if (selectedCountry && isAuthenticated) {
            fetchProvinces();
            fetchDistricts();
            fetchVillages();
        }
    }, [selectedCountry, isAuthenticated]);
    useEffect(() => {
        if (districts && selectedProvince) {
            setFilteredDistricts(
                districts.filter((district) => district.adm1_id === parseInt(selectedProvince))
            );
            setSelectedDistrict(null);
        } else {
            setFilteredDistricts(null);
            setSelectedDistrict(null);
            setFilteredVillages(null);
            setSelectedVillage(null);
        }
    }, [selectedProvince, districts]);
    useEffect(() => {
        if (villages && selectedDistrict) {
            setFilteredVillages(
                villages.filter((village) => village.adm2_id === parseInt(selectedDistrict))
            );
            setSelectedVillage(null);
        } else {
            setFilteredVillages(null);
        }
    }, [selectedDistrict, villages]);
    const fetchFishermen = async (term = searchTerm, forExport = false) => {
        if (!selectedCountry) return;
        setIsLoading(true);
        setFetchError(null);
        if (!activeTab) {
            setActiveTab('active');
        }
        try {
            let url = `${envConfig.API_URL}/fishermen?country_id=${selectedCountry}&status=${activeTab ?? 'active'}`;
            if (!forExport) {
                url += `&page=${pageNo}&size=${perPage}`;
            } else {
                url += `&size=10000`; // Fetch all data for export
            }
            if (selectedProvince) url += `&adm1_id=${selectedProvince}`;
            if (selectedDistrict) url += `&adm2_id=${selectedDistrict}`;
            if (selectedVillage) url += `&adm3_id=${selectedVillage}`;
            if (term) url += `&search_for=${encodeURIComponent(term)}`;
            const response = await fetch(url, {
                headers: getAuthHeaders(),
            });
            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }
            const data = await response.json();
            if (data.success === 1) {
                if (forExport) {
                    return data.data || [];
                }
                setFisherMen(data.data || []);
                const newTotalRows = data.metadata?.total_count || data.data.length;
                setTotalRows(newTotalRows);
            } else {
                throw new Error('API request failed');
            }
        } catch (error) {
            setFetchError(handleApiError(error, error.response));
            setFisherMen([]);
            setTotalRows(0);
            return [];
        } finally {
            setIsLoading(false);
        }
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if (!selectedCountry) {
            setFormError('Country selection is mandatory.');
            return;
        }
        setFormError(null);
        setPageNo(1);
        fetchFishermen();
    };
    const handleSearchSubmit = (e) => {
        if (e) e.preventDefault();
        if (!selectedCountry) {
            setFormError('Please select a country before searching.');
            return;
        }
        setPageNo(1);
        setSelectedRows([]);
        fetchFishermen();
    };
    useEffect(() => {
        const fetchOffcanvasProvinces = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm1?country_id=${offcanvasCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setOffcanvasProvinces(data.data || []);
            } catch (error) {
                setOffcanvasFormError(handleApiError(error, error.response));
            }
        };
        const fetchLanguages = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/advisory/language?country_id=${offcanvasCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setLanguages(data.data || []);
            } catch (error) {
                setOffcanvasFormError(handleApiError(error, error.response));
            }
        };
        const fetchSpecies = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/fishes/species?country_id=${offcanvasCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setSpecies(data.data || []);
            } catch (error) {
                setOffcanvasFormError(handleApiError(error, error.response));
            }
        };
        if (offcanvasCountry && isAuthenticated) {
            fetchOffcanvasProvinces();
            fetchLanguages();
            fetchSpecies();
            if (!isEditMode) {
                setOffcanvasProvince('');
                setOffcanvasDistrict('');
                setOffcanvasVillage('');
                setOffcanvasDistricts(null);
                setOffcanvasVillages(null);
            }
        }
    }, [offcanvasCountry, isAuthenticated, isEditMode]);
    useEffect(() => {
        const fetchOffcanvasDistricts = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm2?country_id=${offcanvasCountry}&adm1_id=${offcanvasProvince}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setOffcanvasDistricts(data.data || []);
            } catch (error) {
                setOffcanvasFormError(handleApiError(error, error.response));
            }
        };
        if (offcanvasProvince && isAuthenticated) {
            fetchOffcanvasDistricts();
            if (!isEditMode) {
                setOffcanvasDistrict('');
                setOffcanvasVillage('');
                setOffcanvasVillages(null);
            }
        }
    }, [offcanvasProvince, isAuthenticated, isEditMode]);
    useEffect(() => {
        const fetchOffcanvasVillages = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm3?country_id=${offcanvasCountry}&adm1_id=${offcanvasProvince}&adm2_id=${offcanvasDistrict}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setOffcanvasVillages(data.data || []);
            } catch (error) {
                setOffcanvasFormError(handleApiError(error, error.response));
            }
        };
        if (offcanvasDistrict && isAuthenticated) {
            fetchOffcanvasVillages();
            if (!isEditMode) {
                setOffcanvasVillage('');
            }
        }
    }, [offcanvasProvince, offcanvasDistrict, isAuthenticated, isEditMode]);
    useEffect(() => {
        const fetchFrequencies = async () => {
            try {
                const response = await fetch(`${envConfig.API_URL}/lookups/advisory/frequency_preference`, {
                    headers: getAuthHeaders(),
                });
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setFrequencies(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };
        if (isAuthenticated) {
            fetchFrequencies();
        }
    }, [isAuthenticated]);
    const onCountryChange = (e) => {
        setSelectedCountry(e.target.value);
        setProvinces(null);
        setDistricts(null);
        setVillages(null);
        setFilteredProvinces(null);
        setFilteredDistricts(null);
        setFilteredVillages(null);
        setSelectedProvince(null);
        setSelectedDistrict(null);
        setSelectedVillage(null);
        // setSearchTerm('');
        // setPageNo(1);
        // setPerPage(5);
        // setSelectedRows([]);
        // setFisherMen([]);
        // setTotalRows(0);
    };
    const handleOffcanvasSubmit = async (e) => {
        e.preventDefault();
        setOffcanvasFormError(null);
        if (!name || !phone || !email || !offcanvasCountry || !offcanvasProvince || !offcanvasDistrict || !offcanvasVillage || !languageId || !speciesId || !advisoryPreferenceId) {
            setOffcanvasFormError('All fields are mandatory.');
            return;
        }
        const payload = {
            country_id: parseInt(offcanvasCountry),
            adm1_id: parseInt(offcanvasProvince),
            adm2_id: parseInt(offcanvasDistrict),
            adm3_id: parseInt(offcanvasVillage),
            status: activeTab,
            name,
            phone,
            email,
            language_id: parseInt(languageId),
            species_id: parseInt(speciesId),
            advisory_preference_id: parseInt(advisoryPreferenceId),
            ...(isEditMode && { purpose: 'update', fisher_id: selectedFisherId }),
        };
        try {
            const response = await fetch(`${envConfig.API_URL}/fishermen`, {
                method: isEditMode ? 'PATCH' : 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (!response.ok || result.success === 0) {
                throw new Error(result.message || `Error: ${response.status}`);
            }
            await Swal.fire({
                title: isEditMode ? 'Updated!' : 'Saved!',
                text: isEditMode
                    ? `${name} has been successfully updated.`
                    : `${name} has been added successfully.`,
                icon: 'success',
                confirmButtonText: 'OK',
            });
            await fetchFishermen();
            handleClose();
        } catch (error) {
            const message = error.message || 'Failed to submit the form.';
            setOffcanvasFormError(message);
            Swal.fire({
                title: 'Error!',
                text: message,
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };
    const handleExportData = async () => {
        if (!selectedCountry) {
            Swal.fire({
                title: 'Country Required',
                text: 'Please select a country before exporting data.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }
        try {
            Swal.fire({
                title: 'Preparing Export...',
                text: 'Fetching data for export. Please wait...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const allFishermen = await fetchFishermen(searchTerm, true);
            if (!allFishermen.length) {
                Swal.fire({
                    title: 'No Data',
                    text: 'No fishermen data available to export.',
                    icon: 'info',
                    confirmButtonText: 'OK',
                });
                return;
            }
            const exportData = allFishermen.map((row, index) => ({
                SNo: index + 1,
                Name: row.name || '--',
                Phone: row.phone || '--',
                Province: row.adm1 || 'Province Name',
                District: row.adm2 || 'District Name',
                [selectedCountry == 1 ? 'EPA' : 'Camp']: row.adm3 || (selectedCountry == 1 ? 'EPA Name' : 'Camp Name'),
                Status: row.active ? 'Active' : 'Deleted',
            }));
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const headerStyle = {
                font: { bold: true },
                fill: { fgColor: { rgb: '2E7D32' } },
                color: { rgb: 'FFFFFF' },
            };
            const headers = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1'];
            headers.forEach((cell) => {
                if (worksheet[cell]) {
                    worksheet[cell].s = headerStyle;
                }
            });
            const colWidths = [
                { wch: 10 },
                { wch: 20 },
                { wch: 20 },
                { wch: 25 },
                { wch: 25 },
                { wch: 25 },
                { wch: 15 },
            ];
            worksheet['!cols'] = colWidths;
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Fishermen');
            const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            const filename = `Fishermen_Country_${selectedCountry}_${timestamp}.xlsx`;
            XLSX.writeFile(workbook, filename);
            Swal.fire({
                title: 'Export Successful!',
                text: `Data has been exported as ${filename}.`,
                icon: 'success',
                confirmButtonText: 'OK',
            });
        } catch (error) {
            Swal.fire({
                title: 'Export Failed',
                text: error.message || 'An unexpected error occurred while exporting data.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };
    const columns = [
        {
            name: 'SNo',
            selector: (row, index) => {
                const sno = index + 1 + (pageNo - 1) * perPage;
                return sno;
            },
            sortable: false,
            width: '60px',
        },
        {
            name: 'Name',
            selector: (row) => row.name || '--',
            sortable: true,
        },
        {
            name: 'Phone',
            selector: (row) => row.phone || '--',
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row) => row.email || '--',
            sortable: true,
        },
        {
            name: 'Language',
            selector: (row) => row.language || '--',
            sortable: true,
        },
        {
            name: 'Species',
            selector: (row) => row.species || '--',
            sortable: true,
        },
        {
            name: 'Frequency',
            selector: (row) => row.advisory_preference || '--',
            sortable: true,
        },
        {
            name: 'Province',
            selector: (row) => row.adm1 || 'Province Name',
            sortable: true,
        },
        {
            name: 'District',
            selector: (row) => row.adm2 || 'District Name',
            sortable: true,
        },
        {
            name: selectedCountry == 1 ? 'EPA' : 'Camp',
            selector: (row) =>
                row.adm3 || (selectedCountry == 1 ? 'EPA Name' : 'Camp Name'),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.active || 'Active',
            sortable: true,
            cell: (row) => (
                <span className="status">{row.active ? 'Active' : 'Deleted'}</span>
            ),
        },
        {
            name: 'Options',
            cell: (row) => (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    {row.active ? (
                        <>
                            <button
                                className="btn btn-default p-0"
                                onClick={() => handleEdit(row)}
                                title="Edit"
                            >
                                <img src="./assets/images/edit.svg" alt="Edit" />
                            </button>
                            <button
                                className="btn btn-default p-0"
                                onClick={() => handleDelete(row)}
                                title="Delete"
                            >
                                <img src="./assets/images/delete.svg" alt="Delete" />
                            </button>
                        </>
                    ) : (
                        <button
                            type="submit"
                            className="btn btn-search mb-1"
                            style={{ width: '130px', margin: '5px 0 0 0' }}
                            onClick={() => handleActivate(row)}
                        >
                            Re-activate
                        </button>
                    )}
                </div>
            ),
            ignoreRowClick: true,
        },
    ];
    const handlePageChange = (page) => {
        setPageNo(page);
        setSelectedRows([]);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setPageNo(page);
        setSelectedRows([]);
    };
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setPageNo(1);
        setPerPage(5);
        setSelectedRows([]);
        setFisherMen([]);
        setTotalRows(0);
    };
    useEffect(() => {
        if (selectedCountry && pageNo && perPage) {
            fetchFishermen();
        }
    }, [pageNo, perPage, activeTab]);
    const handleRowSelected = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };
    const customStyles = {
        table: {
            style: {
                border: '1px solid #dee2e6',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#2e7d32',
                color: '#ffffff',
                fontWeight: 'bold',
                borderBottom: '1px solid #dee2e6',
            },
        },
        headCells: {
            style: {
                padding: '10px 15px!important',
                borderRight: '1px solid #dee2e6',
            },
        },
        cells: {
            style: {
                padding: '5px 15px',
                borderRight: '1px solid #dee2e6',
            },
        },
        rows: {
            style: {
                maxHeight: '40px',
                '&:hover': {
                    backgroundColor: '#f1f1f1',
                },
            },
        },
        pagination: {
            style: {
                padding: '4px 8px',
                minHeight: '40px',
                border: 'none',
                padding: '5px 5px 5px 5px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                backgroundColor: '#e8f5e9',
            },
            pageButtonsStyle: {
                backgroundColor: 'transparent',
                border: 'none',
                color: '#000',
                padding: '0.25rem 0.5rem',
                margin: '0 0.25rem',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#d4edda',
                },
                '&:disabled': {
                    opacity: 0.5,
                    cursor: 'not-allowed',
                },
            },
        },
    };
    const sampleDownload = async () => {
        if (!offcanvasCountry) {
            Swal.fire({
                title: 'Country Required',
                text: 'Please select a country before downloading the sample file.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }
        try {
            Swal.fire({
                title: 'Preparing Download...',
                text: 'Fetching sample file. Please wait...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const response = await fetch(`${envConfig.API_URL}/fishermen/sheet?country_id=${offcanvasCountry}&sheet_format=xlsx`, {
                method: 'GET',
                headers: getAuthHeaders(),
            });
            if (!response.ok) {
                throw new Error('Download failed. Please check the country ID or your permissions.');
            }
            const blob = await response.blob();
            if (blob.size < 1024) {
                throw new Error("Received file is too small. It may be an error page instead of a real file.");
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Fish_Farmers_Bulk_Upload_Template_${offcanvasCountry}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            Swal.fire({
                title: 'Download Ready!',
                text: 'The sample file has been downloaded successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
            });
        } catch (error) {
            Swal.fire({
                title: 'Download Failed',
                text: error.message || 'An unexpected error occurred while downloading the file.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };
    const handleBulkUploadSubmit = async () => {
        if (!uploadFile) {
            Swal.fire({
                title: 'No File Selected',
                text: 'Please select a valid Excel file before uploading.',
                icon: 'info',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (!offcanvasCountry) {
            Swal.fire({
                title: 'Country Required',
                text: 'Please select a country before uploading.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }
        try {
            Swal.fire({
                title: 'Uploading...',
                text: 'Please wait while your file is being processed.',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const formData = new FormData();
            formData.append('attachment', uploadFile);
            formData.append('country_id', offcanvasCountry);
            const response = await fetch(`${envConfig.API_URL}/fishermen/sheet`, {
                method: 'POST',
                headers: {
                    Authorization: getAuthHeaders().Authorization,
                },
                body: formData,
            });
            const result = await response.json();
            if (!response.ok || result.success === 0) {
                let errorMessage = result.message || 'Upload failed.';
                let errorDetails = '';
                if (result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
                    errorDetails = `
                        <div style="text-align: left; max-height: 200px; overflow-y: auto;">
                            <p style="margin-bottom: 10px;"><strong>Details:</strong></p>
                            <ul style="list-style-type: disc; padding-left: 20px;">
                                ${result.errors.map(error => `<li>${error}</li>`).join('')}
                            </ul>
                        </div>
                    `;
                } else {
                    errorDetails = `<p style="text-align: left;">No specific error details provided.</p>`;
                }
                Swal.fire({
                    title: 'Upload Failed',
                    html: `
                        <p style="text-align: left; margin-bottom: 15px;">${errorMessage}</p>
                        ${errorDetails}
                    `,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'swal-wide',
                        htmlContainer: 'swal-html-container',
                    },
                });
                return;
            }
            Swal.fire({
                title: 'Upload Successful!',
                text: result.message || 'Your file has been uploaded successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
            });
            setUploadFile(null);
            const fileInput = document.getElementById('file-input');
            if (fileInput) {
                fileInput.value = null;
            }
            await fetchFishermen();
            handleCloseBulkUpload();
        } catch (error) {
            Swal.fire({
                title: 'Upload Failed',
                text: error.message || 'An unexpected error occurred during upload.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };
    const handleFileChange = (file) => {
        if (file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    title: 'Invalid File Type',
                    text: 'Only .xlsx files are allowed.',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                });
                const fileInput = document.getElementById('file-input');
                if (fileInput) {
                    fileInput.value = null;
                }
                return;
            }
            if (file.size > 1 * 1024 * 1024) {
                Swal.fire({
                    title: 'File Too Large',
                    text: 'File size must be less than 1MB.',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                });
                const fileInput = document.getElementById('file-input');
                if (fileInput) {
                    fileInput.value = null;
                }
                return;
            }
            setUploadFile(file);
        }
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        handleFileChange(file);
    };
    return (
        <>
            <div className="wrapper pt-100px one">
                <div className="container-fluid">
                    <div className="row pt-3">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="box-config">
                                <h5>Fish Farmers</h5>
                                <form onSubmit={handleFilterSubmit} className="">
                                    <div className="row mb-3">
                                        <div className="col-sm-12 col-md-5 col-lg-5">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 col-lg-6">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="country">Country <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedCountry || ''}
                                                            onChange={onCountryChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {countries &&
                                                                countries.map((country) => (
                                                                    <option key={country.country_id} value={country.country_id}>
                                                                        {country.country || country.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="province">Province</label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedProvince || ''}
                                                            onChange={(e) => setSelectedProvince(e.target.value)}
                                                            disabled={!selectedCountry}
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredProvinces &&
                                                                filteredProvinces.map((province) => (
                                                                    <option key={province.adm1_id} value={province.adm1_id}>
                                                                        {province.adm1 || province.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-5 col-lg-5">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 col-lg-6">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="district">District</label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedDistrict || ''}
                                                            onChange={(e) => setSelectedDistrict(e.target.value)}
                                                            disabled={!selectedProvince}
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredDistricts &&
                                                                filteredDistricts.map((district) => (
                                                                    <option key={district.adm2_id} value={district.adm2_id}>
                                                                        {district.adm2 || district.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="village">{selectedCountry == 1 ? 'EPA' : 'Camp'}</label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedVillage || ''}
                                                            onChange={(e) => setSelectedVillage(e.target.value)}
                                                            disabled={!selectedDistrict}
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredVillages &&
                                                                filteredVillages.map((village) => (
                                                                    <option key={village.adm3_id} value={village.adm3_id}>
                                                                        {village.adm3 || village.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-2 col-lg-2">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-12 col-lg-12">
                                                    <button type="submit" className="btn btn-apply" style={{ height: '38px' }}>
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                {formError && <div className="text-danger mt-2">{formError}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg">
                            <div className="filter-box border p-2" style={{ borderRight: '0px', height: 'auto' }}>
                                <h5 className="text-capitalize">Target Fish Farmers</h5>
                                <div className="d-flex bg-light">
                                    <div
                                        className={`tab ${activeTab === 'active' ? 'active-tab' : ''}`}
                                        onClick={() => handleTabClick('active')}
                                        style={{ cursor: 'pointer', padding: '10px 20px', fontSize: '14px', fontWeight: '500', borderBottom: activeTab === 'active' ? '2px solid #2e7d32' : 'none' }}
                                    >
                                        Active
                                    </div>
                                    <div
                                        className={`tab ${activeTab === 'deleted' ? 'active-tab' : ''}`}
                                        onClick={() => handleTabClick('deleted')}
                                        style={{ cursor: 'pointer', padding: '10px 20px', fontSize: '14px', fontWeight: '500', borderBottom: activeTab === 'deleted' ? '2px solid #2e7d32' : 'none' }}
                                    >
                                        Deleted
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div>
                                        {selectedRows.length > 0 && (
                                            <p className="mb-0">{selectedRows.length} row(s) selected</p>
                                        )}
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <form onSubmit={handleSearchSubmit} className="d-flex align-items-center">
                                            <div className="searchBox me-2">
                                                <input
                                                    type="text"
                                                    placeholder="Search by name or phone number"
                                                    className="form-control"
                                                    value={searchTerm}
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                    }}
                                                />
                                                <span><img src="./assets/images/search.svg" alt="" /></span>
                                            </div>
                                            <button
                                                type="submit"
                                                className="btn btn-search"
                                            >
                                                Search
                                            </button>
                                        </form>
                                        <div>
                                            <button className="btn btn-new ms-2 pe-2" onClick={reset} style={{ marginBottom: '23px' }}>
                                                Reset
                                            </button>
                                        </div>
                                        <div>
                                            <button className="btn btn-new ms-2 pe-2" onClick={handleShow} style={{ marginBottom: '23px' }}>
                                                <span><img src="./assets/images/add.svg" alt="" style={{ height: '21px' }} /></span>Add New
                                            </button>
                                        </div>
                                        <div>
                                            <button className="btn btn-new ms-2 pe-2" onClick={handleShowBulkUpload} style={{ marginBottom: '23px' }}>
                                                <span><img src="./assets/images/add.svg" alt="" style={{ height: '21px' }} /></span>Bulk upload
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                className="btn btn-new ms-2 pe-2"
                                                onClick={handleExportData}
                                                style={{ marginBottom: '23px' }}
                                                disabled={!selectedCountry}
                                                title="Export all data to Excel"
                                            >
                                                <span>
                                                    <img
                                                        src="./assets/images/download.svg"
                                                        alt=""
                                                        style={{ height: '21px' }}
                                                    />
                                                </span>
                                                Export Data
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <DataTable
                                    key={activeTab}
                                    columns={columns}
                                    data={fisherMen}
                                    // selectableRows
                                    // onSelectedRowsChange={handleRowSelected}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationDefaultPage={pageNo}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    paginationRowsPerPageOptions={[5, 10, 25, 50]}
                                    paginationPerPage={perPage}
                                    paginationComponentOptions={{
                                        rowsPerPageText: 'Records per page:',
                                        rangeSeparatorText: 'of',
                                        selectAllRowsItem: false,
                                    }}
                                    customStyles={customStyles}
                                    noDataComponent={<div className="text-center p-2 font-14px">No Fish Farmers found</div>}
                                    highlightOnHover
                                    dense
                                    keyField="fisher_id"
                                    progressPending={isLoading}
                                    progressComponent={<div className="text-center p-2 font-14px">Loading...</div>}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            <Offcanvas show={show} onHide={handleClose} placement="end" {...props}>
                <Offcanvas.Body>
                    <div className="add-new-box">
                        <h5>{isEditMode ? 'Edit Fish Farmer Record' : 'New Fish Farmer Record'}</h5>
                        <form onSubmit={handleOffcanvasSubmit}>
                            <div className="form-group">
                                <label htmlFor="country">Country <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="country"
                                    value={offcanvasCountry}
                                    onChange={(e) => setOffcanvasCountry(e.target.value)}
                                    required
                                    disabled={selectedCountry !== null && selectedCountry !== ''}
                                >
                                    <option value="">Select</option>
                                    {countries &&
                                        countries.map((country) => (
                                            <option key={country.country_id} value={country.country_id}>
                                                {country.country || country.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="province">Province <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="province"
                                    value={offcanvasProvince}
                                    onChange={(e) => setOffcanvasProvince(e.target.value)}
                                    required
                                    disabled={!offcanvasProvinces}
                                >
                                    <option value="">Select</option>
                                    {offcanvasProvinces &&
                                        offcanvasProvinces.map((province) => (
                                            <option key={province.adm1_id} value={province.adm1_id}>
                                                {province.adm1 || province.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="district">District <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="district"
                                    value={offcanvasDistrict}
                                    onChange={(e) => setOffcanvasDistrict(e.target.value)}
                                    required
                                    disabled={!offcanvasDistricts}
                                >
                                    <option value="">Select</option>
                                    {offcanvasDistricts &&
                                        offcanvasDistricts.map((district) => (
                                            <option key={district.adm2_id} value={district.adm2_id}>
                                                {district.adm2 || district.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="village">{selectedCountry == 1 ? 'EPA' : 'Camp'} <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="village"
                                    value={offcanvasVillage}
                                    onChange={(e) => setOffcanvasVillage(e.target.value)}
                                    required
                                    disabled={!offcanvasVillages}
                                >
                                    <option value="">Select</option>
                                    {offcanvasVillages &&
                                        offcanvasVillages.map((village) => (
                                            <option key={village.adm3_id} value={village.adm3_id}>
                                                {village.adm3 || village.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Phone <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="phone"
                                    placeholder="Enter phone number with country code"
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    maxLength="16"
                                    required
                                    pattern="^\d{1,16}$"
                                    title="Phone number must contain only digits, up to 16 characters."
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email <span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="language">Language Preference <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="language"
                                    value={languageId}
                                    onChange={(e) => setLanguageId(e.target.value)}
                                    required
                                    disabled={!languages.length}
                                >
                                    <option value="">Select</option>
                                    {languages.map((lang) => (
                                        <option key={lang.language_id} value={lang.language_id}>
                                            {lang.language}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="species">Species Selection <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="species"
                                    value={speciesId}
                                    onChange={(e) => setSpeciesId(e.target.value)}
                                    required
                                    disabled={!species.length}
                                >
                                    <option value="">Select</option>
                                    {species.map((spec) => (
                                        <option key={spec.species_id} value={spec.species_id}>
                                            {spec.species}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="frequency">Frequency Preference <span className="text-danger">*</span></label>
                                <select
                                    className="form-select custom-select"
                                    id="frequency"
                                    value={advisoryPreferenceId}
                                    onChange={(e) => setAdvisoryPreferenceId(e.target.value)}
                                    required
                                    disabled={!frequencies.length}
                                >
                                    <option value="">Select</option>
                                    {frequencies.map((freq) => (
                                        <option key={freq.advisory_preference_id} value={freq.advisory_preference_id}>
                                            {freq.preference}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {offcanvasFormError && <div className="text-danger">{offcanvasFormError}</div>}
                            <div className="row pt-5 mt-150px">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <button type="button" className="btn btn-cancel w-100" onClick={handleClose}>
                                        Cancel
                                    </button>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <button type="submit" className="btn btn-submit w-100">
                                        {isEditMode ? 'Update' : 'Save'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <Offcanvas show={showBulkUpload} onHide={handleCloseBulkUpload} placement="end" {...props}>
                <Offcanvas.Body>
                    <div className="add-new-box">
                        <h5>New Fish Farmers - Bulk Upload</h5>
                        <div className="form-group">
                            <label htmlFor="bulk-country">Country <span className="text-danger">*</span></label>
                            <select
                                className="form-select custom-select"
                                id="bulk-country"
                                value={offcanvasCountry}
                                onChange={(e) => setOffcanvasCountry(e.target.value)}
                                required
                                disabled={selectedCountry !== null && selectedCountry !== ''}
                            >
                                <option value="">Select</option>
                                {countries &&
                                    countries.map((country) => (
                                        <option key={country.country_id} value={country.country_id}>
                                            {country.country || country.name}
                                        </option>
                                    ))}
                            </select>
                        </div>
                        <button
                            className="btn btn-cancel w-100 mt-3"
                            onClick={sampleDownload}
                            disabled={!offcanvasCountry}
                            title="Download Excel template for bulk upload"
                        >
                            Download Template
                        </button>
                        <div className="card border-0 mt-3" style={{ backgroundColor: '#fff' }}>
                            <div className="card-body">
                                <div className="form-group mb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <label>Upload Documents <span className="text-danger">*</span></label>
                                    </div>
                                    <label><small>Kindly download the template and input the data according to the format specified in the template.</small></label>
                                    <br />
                                    <label><small>Formats accepted: .xlsx files only</small></label>
                                </div>
                                <div
                                    className="upload-box mb-3"
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                    onClick={() => document.getElementById('file-input').click()}
                                >
                                    <p className="mb-2"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none">
                                        <g opacity="0.3">
                                            <path d="M22.6667 23.1671L17 17.5004M17 17.5004L11.3333 23.1671M17 17.5004V30.2504M28.8858 26.5529C30.2676 25.7996 31.3591 24.6077 31.9882 23.1651C32.6172 21.7226 32.748 20.1117 32.3598 18.5866C31.9716 17.0615 31.0866 15.7091 29.8445 14.7428C28.6023 13.7765 27.0737 13.2515 25.5 13.2504H23.715C23.2862 11.5919 22.487 10.0521 21.3774 8.74683C20.2679 7.4416 18.8769 6.40488 17.309 5.71462C15.7411 5.02436 14.0371 4.69852 12.3252 4.76159C10.6132 4.82467 8.93785 5.27502 7.425 6.07878C5.91216 6.88255 4.60121 8.01882 3.59072 9.40217C2.58023 10.7855 1.89648 12.3799 1.59089 14.0656C1.2853 15.7512 1.36582 17.4842 1.82639 19.1342C2.28696 20.7842 3.1156 22.3084 4.25001 23.5921" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                    </svg></p>
                                    <p>Drag and drop a file here or click to open folder</p>
                                    <input
                                        type="file"
                                        id="file-input"
                                        onChange={(e) => handleFileChange(e.target.files[0])}
                                        accept=".xlsx"
                                        style={{ display: "none" }}
                                    />
                                    {uploadFile && (
                                        <div className="file-list">
                                            <div>📄 {uploadFile.name}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row pt-5 mt-4">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <button
                                    className="btn btn-cancel w-100"
                                    onClick={handleCloseBulkUpload}
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <button
                                    className="btn btn-submit w-100"
                                    onClick={handleBulkUploadSubmit}
                                    disabled={!uploadFile || !offcanvasCountry}
                                >
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}
export default Fisherman;